// src/components/DocumentView.tsx
import React from 'react';
import { DocumentData } from '../types/Document.ts';

interface DocumentViewProps {
  document: DocumentData | null;
}

const DocumentView: React.FC<DocumentViewProps> = ({ document }) => {
  if (!document) return <div>表示するドキュメントがありません。</div>;

  return (
    <div style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '10px' }}>
      <h3>{document.title}</h3>
      <pre style={{ whiteSpace: 'pre-wrap' }}>{document.content}</pre>
    </div>
  );
};

export default DocumentView;
